import React from 'react';
import styled from 'styled-components';
import { Box, Link, style, Text } from '@do/walrus';
import inviteErrorImage from '../assets/illustrations/invite-error.png';
import { ReactComponent as logoFullSrc } from '../assets/logo-full-white.svg';
import copy from '../copy';

const Container = styled.div`
  display: grid;
  width: 100%;
  height: calc(100vh - ${style.vars.space['10']});
  margin-top: ${style.vars.space['10']};
  place-items: center;
  padding: ${style.vars.space['5']} 0;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h4,
  p {
    text-align: center;
  }
`;

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${style.vars.space['10']};
  padding-left: ${style.vars.space['5']};
  padding-right: ${style.vars.space['5']};
  background: ${style.colors.blue.primary};
  z-index: ${style.vars.zIndex.raised};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
`;

const LogoSVG = styled(logoFullSrc)`
  width: 100%;
  height: 30px;
  fill: ${style.colors.white};
`;

const DOLogoLink = () => {
  return (
    <Link target="_self" to="https://www.digitalocean.com" aria-label="DigitalOcean Home">
      <Box p={2}>
        <LogoSVG aria-hidden="true" focusable="false" />
      </Box>
    </Link>
  );
};

export const InviteErrorPage = () => {
  return (
    <>
      <Header>
        <DOLogoLink />
      </Header>
      <Container>
        <Box maxWidth="600px" ml={3} mr={3} border="base" p={6}>
          <Content>
            <img
              src={inviteErrorImage}
              alt="An octopus holds a webpage with an exclamation mark above its head, while a crab looks on"
            />
            <Text type="h4">{copy.inviteError.title}</Text>
            <Text type="p">{copy.inviteError.description}</Text>
          </Content>
        </Box>
      </Container>
    </>
  );
};
